// i18n area 'backups' — locale cs-CZ (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.cs-CZ.meta.json.
import type { enUS } from './backups'

export const csCZ: typeof enUS = {
  ckpt: {
    contents: 'Přijímá',
    contentsHint:
      'Co sem smí přistát. „Checkpointy“ je konfigurace clusteru, „Zálohy dat“ jsou zálohy virtuálních strojů: obě čtení se skládají, jeden cíl může přijmout obojí.',
    content: { checkpoints: 'Checkpointy', backups: 'Zálohy dat' },
    destinationsTitle: 'Cíle záloh',
    checkpointsTitle: 'Checkpointy',
    restoreTitle: 'Obnovení',
    addDestination: 'Přidat cíl',
    addDestinationTitle: 'Přidat cíl záloh',
    editDestinationTitle: 'Upravit cíl',
    storage: 'Úložiště',
    storageHint: 'Dir-like úložiště (dir/NFS/CIFS/CephFS) — artefakty jsou obyčejné soubory pod namespacem platformy.',
    schedule: 'Plánování',
    scheduleNone: 'Pouze ručně',
    scheduleHourly: 'Každou hodinu',
    scheduleDaily: 'Denně',
    scheduleWeekly: 'Týdně',
    scheduleHour: 'Hodina',
    scheduleWeekday: 'Den',
    scheduleHint:
      'Plánované checkpointy nemají operátora, který by zadal masterpass: tajemství z keystore se balí jako placeholdery.',
    retention: 'Retention',
    retentionHint:
      'Kolik plánovaných checkpointů držet — sweeper odstraňuje nejstarší nad tento počet. Ruční checkpointy a checkpointy před obnovením se nikdy neodstraňují.',
    paused: 'Pozastaveno',
    pausedHint:
      'Blackout operátora: dokud pauza trvá, na tomto cíli se nic neplánuje a nic neprořezává — datové policy i checkpointy stejně. Běžících běhů se nikdy nedotýká.',
    orphanRuns: '{n} osiřelých běhů',
    orphanRunsHint:
      'Plánované běhy policy, které na tomto cíli už neexistují: žádná retence je neřídí — nikdy se nepočítají ani neprořezávají — a maže je jen ruka. Čočka „backups“ v tvirt diagnose jmenuje odstraněné policy.',
    rescan: 'Znovu přijmout artefakty',
    rescanTitle: 'Opětovné přijetí artefaktů {name}',
    rescanHint:
      'Znovu sestaví katalog záloh (VM/CT/App) z manifestů artefaktů přítomných v cíli. Existující řádky se nikdy nemění; zálohy neznámých politik zůstávají sirotky (nikdy se automaticky neprořezávají). Krok po bootstrap obnově.',
    masterpassDrWarning:
      'Scénář katastrofy: disky LUKS se vrátí POUZE z checkpointu S masterpass. Plánované checkpointy balí zástupné hodnoty — pravidelně pořizujte ruční checkpoint s masterpass.',
    policy: {
      title: 'Policy záloh dat',
      hint: 'Pojmenované policy: které objekty (kind, tagy, scopy), jak často, kdy smí běh začít a kolik kopií držet. Gesto zápisu zůstává vlastníkovi objektu: tagy se přidělují na jeho vlastním scopu.',
      add: 'Přidat policy',
      column: 'Datové policy',
      name: 'Název',
      nameHint:
        'Štítek policy, jedinečný v rámci cíle. Běhy sledují stabilní id policy: přejmenování je zdarma; smazání osiří její běhy (už se nepočítají ani neprořezávají).',
      kindLocked: 'Rodinu objektů existující policy nelze změnit: vytvořte novou policy.',
      kindLabel: 'Objekty',
      kind: { vm: 'Virtuální stroje', ct: 'Kontejnery', app: 'Aplikace' },
      tags: 'Selektor tagů',
      tagsHint: 'Dvojice tag=hodnota oddělené čárkami, spojené AND. Prázdné tagy a scopy nevybírají nic — nikdy „vše“.',
      scopes: 'Scopy',
      scopesHint: 'Cesty scopů (podstromy), oddělené čárkami, mezi sebou v OR.',
      windowStart: 'Okno od',
      windowEnd: 'Okno do',
      windowHint:
        'Okno spuštění (HH:MM, místní čas; začátek za koncem překračuje půlnoc). Řídí jen START: běh, který je přetáhne, se nikdy nezabíjí.',
      mode: 'Režim',
      modeHint: 'Inkrementální jede na rodině sérií; přetržená série degraduje na full, řečeno v deníku.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementální',
      requireQuiesce: 'Vyžadovat quiesce (guest agent)',
      paused: 'Policy pozastavena',
      retentionNone: 'Držet vše',
      retentionCount: 'Počet',
      retentionGfs: 'Kruhy GFS',
      gfs: { keepLast: 'Poslední', daily: 'Denní', weekly: 'Týdenní', monthly: 'Měsíční', yearly: 'Roční' },
      gfsHint:
        'Pro každý kruh se drží nejnovější záloha z každého z posledních N období. Držená záloha udržuje naživu celý svůj řetěz — nikdy základ se sirotky.',
      lastRun: 'Poslední běh',
      neverRan: 'nikdy neproběhlo'
    },
    lastCheckpoint: 'Poslední checkpoint',
    neverRun: 'Nikdy nevytvořeno',
    createNow: 'Vytvořit checkpoint',
    createNowTitle: 'Vytvořit checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Chrání tajné hodnoty v keystore (argon2id → AES-256-GCM, po hodnotách). Nikdy se neukládá: uchovejte si ho — bez něj obnovení vydá placeholdery místo skutečných tajemství.',
    masterpassEmptyHint: 'Ponechte prázdné, chcete-li místo tajemství zabalit explicitní placeholdery.',
    createStarted: 'Checkpoint běží…',
    destinationInUseError: "'{name}' stále obsahuje checkpointy — nejprve je odstraňte.",
    origin: 'Původ',
    originManual: 'ruční',
    originSchedule: 'plánovaný',
    originPreRestore: 'před obnovením',
    originPreChange: 'před změnou',
    preChangeRetention: 'Checkpointy před změnou',
    preChangeRetentionHint:
      'Prázdné = vypnuto. První zápis konfigurace po období klidu zde zmrazí předchozí stav (původ „před změnou“); nejnovější se uchovávají do počtu — vlastní, prořezávaná retence.',
    diffTitle: 'Náhled změn',
    diffFailed: 'Náhled se nezdařil',
    diffRetry: 'Zkusit znovu',
    diffCounts: '{changed} ke změně · {missing} k vytvoření · {extra} navíc · {equal} shodných',
    diffChanged: 'mění se',
    diffMissing: 'byl by vytvořen',
    diffExtra: 'byl by smazán',
    diffJsonb: 'jsonb reference nelze ověřit před aplikací',
    diffSecret: 'zapečetěná pole, neporovnatelná',
    diffMore: 'dalších {n}…',
    diffNeeded: 'Start se odjistí, když náhled odpovídá výběru.',
    phase: 'Stav',
    phaseRunning: 'běží',
    phaseComplete: 'dokončen',
    phaseError: 'chyba',
    secrets: 'Tajemství',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholdery',
    size: 'Velikost',
    created: 'Vytvořen',
    destination: 'Cíl',
    download: 'Stáhnout .tvbk',
    deleteCheckpoint: 'Odstranit checkpoint',
    noCheckpoints: 'Žádné checkpointy — vytvořte jeden z některého cíle.',

    // Kolo #156 (standard dialogů): úplný čtecí povrch záznamu archivu —
    // řádky detailu pro pole nikdy neukázaná v tabulce.
    families: 'Rodiny',
    generation: 'Generace',
    completedAt: 'Dokončeno',
    errorDetail: 'Detail chyby',
    manifest: 'Manifest',
    restoreHint: 'Nahrajte artefakt .tvbk: explorer ukáže, co nese, a pak zvolíte, co obnovit a jak.',
    uploadFile: 'Nahrát soubor .tvbk',
    uploading: 'Nahrávání…',
    uploadFailed: 'Artefakt se nepodařilo otevřít',
    explorerTitle: 'Obsah checkpointu',
    checkpointFrom: 'Checkpoint klastru {cluster}, vytvořen {when} ({origin}, generace {generation})',
    otherCluster:
      'Tento checkpoint pochází z JINÉHO klastru ({cluster}) — obnovení napříč klastry přijde v budoucím kole.',
    encrypted: 'šifrovaný',
    objectsCount: 'objektů: {n}',
    mode: 'Režim',
    modeMerge: 'Merge — rekonciliace: upsert vybraných, nic se nemaže',
    modeOverwrite:
      'Overwrite — vyhrává checkpoint: plně vybraná rodina se nahradí celá (aktuální řádky, které v checkpointu nejsou, zaniknou)',
    restoreMasterpassHint:
      'Masterpass, se kterým byl checkpoint vytvořen. Bez něj se šifrovaná tajemství obnoví jako explicitní placeholdery.',
    checkMasterpass: 'Ověřit',
    masterpassOk: 'Masterpass je správný',
    masterpassWrong: 'Nesprávný masterpass',
    parachuteDestination: 'Padákový cíl',
    parachuteHint: 'Než se úloha dotkne jakéhokoli řádku, vytvoří zde automatický checkpoint před obnovením.',
    summaryTitle: 'Co se stane',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'celá rodina',
    summaryObjects: 'vybraných objektů: {n}',
    confirmHint: 'Pro potvrzení napište název klastru ({name}) — obnovení přepisuje deklarovanou konfiguraci.',
    confirmField: 'Název klastru',
    startRestore: 'Obnovit',
    restoreRunning: 'Obnovení běží…',
    restoreDone: 'Obnovení dokončeno — reconcilery konvergují k nové deklaraci.',
    restoreFailed: 'Obnovení selhalo',
    discard: 'Zahodit',
    selectionEmpty: 'Vyberte alespoň jednu rodinu nebo objekt.'
  },

  backup: {
    intro: {
      title: 'Zálohování dat VM a kontejnerů',
      subtitle: 'Stavební kameny, které používá externí zálohovací software',
      whatItIs:
        'TVirt vystavuje čtyři primitivy: quiesced snímky, sledování změn pro každý disk, NBD export pouze pro čtení a export konfigurace. Řídí je Veeam, Bacula, Acronis a spol.',
      whatItIsNot:
        'TVirt není zálohovací produkt: nic neplánuje, neuplatňuje retenci a nedrží žádný archiv vašich dat. Retence, katalogy a politiky obnovení zůstávají na softwaru, který už používáte.'
    },
    cbt: {
      title: 'Sledování změn',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Stav',
      colBitmaps: 'Bitmapy',
      colObservedAt: 'Pozorováno',
      colChangeId: 'Change ID',
      colMechanic: 'Mechanismus',
      stateActive: 'Aktivní',
      stateInactive: 'Vypnuto',
      stateInconsistent: 'Nekonzistentní — další záloha musí být plná',
      stateBroken: 'Řetěz přerušen — vypněte a zapněte jako nový řetěz',
      stateSnapshots: 'Vždy zapnuto — delta mezi snapshoty',
      stateUnavailable: 'Na tomto disku není k dispozici',
      mechanic: {
        'qcow2-bitmap': 'Bitmapa qcow2',
        'rbd-snapdiff': 'Diff snapshotů Ceph',
        'lvm-thin-delta': 'Delta thin poolu',
        none: 'Žádný'
      },
      empty:
        'Žádný disk VM. Sledování změn se čte po discích: zapněte ho na disku qcow2, nebo pořizujte snapshoty na rbd/SAN.',
      chainBroken: 'Řetěz přerušen',
      chainBrokenText:
        'Přerušen událostí {reason}: {bitmaps}. Vypněte bitmapu (řetěz je ztracen, další záloha je plná) a zapněte ji jako nový řetěz.',
      lineages: 'Epochy',
      epochFrozen: 'zmrazena ve snapshotu {snapshot}',
      epochLost: 'ztracena ({cause})',
      epochRecording: 'zaznamenává na hlavě',
      milestones: 'Milníky (snapshoty)',
      enable: 'Zapnout sledování změn',
      disable: 'Vypnout',
      reset: 'Resetovat',
      changedAreas: 'Změněné oblasti',
      denied: 'Chybí vám oprávnění k této VM',
      enableTitle: 'Zapnout sledování změn',
      disableTitle: 'Vypnout sledování změn',
      resetTitle: 'Resetovat bitmapu',
      areasTitle: 'Změněné oblasti',
      bitmapName: 'Název bitmapy',
      bitmapNameHint: 'Vlastní název: tvirt- a tvbk- patří platformě',
      granularity: 'Granularita (bajty)',
      granularityHint: 'Mocnina dvou; výchozí 65536',
      bitmap: 'Bitmapa',
      disableHint: 'Odstraní bitmapu i celou historii jejích epoch: další záloha musí být plná.',
      resetHint: 'Vyprázdní bitmapu — nová základna: change ID starší než reset už nelze složit.',
      areasFrom: 'Od snapshotu',
      areasTo: 'Do snapshotu',
      areasRun: 'Spočítat',
      areasResult: '{count} změněných oblastí, {bytes}',
      areasEmpty: 'Mezi oběma snapshoty není žádná změněná oblast',
      areasZero: 'nuly',
      areasMore: 'zobrazeno prvních {shown} z {count}',
      submit: 'Potvrdit',
      error: 'Akce sledování změn selhala'
    },
    exports: {
      title: 'Otevřené exporty NBD',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmapa',
      colPhase: 'Fáze',
      colNode: 'Uzel',
      colEndpoint: 'Endpoint',
      colExpires: 'Vyprší',
      colCreated: 'Otevřeno',
      colError: 'Chyba',
      phase: {
        preparing: 'Připravuje se',
        ready: 'Připraven',
        closed: 'Zavřen',
        error: 'Selhal'
      },
      expiresIn: 'za {minutes} min',
      expired: 'vypršel',
      empty: 'Žádný export. Relace čtení poskytuje jeden disk v jednom snapshotu klientovi NBD; relace zápisu plní panenský disk zastaveného VM. Obě umírají při vypršení.',
      endpointHint: 'TLS s CA clusteru; název exportu je vstupenka — zaniká se sezením',
      closeDenied: 'Chybí vám oprávnění zavírat exporty této VM',
      open: 'Otevřít export NBD',
      openTitle: 'Otevřít export NBD',
      openDisk: 'Disk',
      openBitmap: 'Bitmapa (volitelně)',
      openBitmapHint:
        'Zveřejní epochu této bitmapy zmrazenou v tomto snapshotu jako meta-context změněných extentů (jen disky qcow2)',
      openTtl: 'Životnost (minuty)',
      openSubmit: 'Otevřít',
      openError: 'Export se nepodařilo otevřít',
      colMode: 'Režim',
      mode: {
        read: 'Čtení',
        write: 'Zápis'
      },
      caCertificate: 'CA clusteru',
      caCopy: 'Kopírovat PEM',
      caDownload: 'Stáhnout ca-cert.pem',
      caHint: 'Zapište PEM do ca-cert.pem v soukromém adresáři a připojte se přes nbds://…?tls-certificates=<adresář> (nbdcopy, nbdinfo) nebo --object tls-creds-x509,dir=<adresář>,endpoint=client (qemu-img)',
      caAbsent: 'Relace nenese CA (žádná PKI)',
      openWrite: 'Otevřít export pro zápis',
      openWriteTitle: 'Otevřít export pro zápis',
      openWriteIntro: 'Disk musí být panenský: zrozen prázdný, nikdy nezapsaný, bez snapshotu; VM zastavené. Obnova disk PLNÍ, neopravuje ho. Dokud je relace otevřená, VM se nespustí, neudělá snapshot, neklonuje se a disk se nepřesune.',
      openWriteSubmit: 'Otevřít',
      openWriteError: 'Export pro zápis se nepodařilo otevřít',
      openWriteDenied: 'Chybí vám vm.restore.data na tomto VM',
      openWriteStopped: 'Zastavte VM, abyste otevřeli export pro zápis',
      fromDescription: 'Vytvořit VM z popisu',
      fromDescriptionTitle: 'Vytvořit VM z popisu',
      fromDescriptionIntro: 'Popis z export-vm-meta se vrací jako zastavené VM s prázdnými disky popsané geometrie — připravené na exporty pro zápis, disk po disku. Bajty tudy neprocházejí: nese je restore-disk (CLI) nebo klient NBD zálohovacího produktu.',
      fromDescriptionDoc: 'Popis (JSON)',
      fromDescriptionDocHint: 'Vložte dokument z export-vm-meta nebo vyberte soubor',
      fromDescriptionFile: 'Vybrat soubor…',
      fromDescriptionInvalid: 'Text není dokument JSON',
      fromDescriptionName: 'Název nového VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Váš domovský scope',
      fromDescriptionStorage: 'Úložiště disků',
      fromDescriptionStorageHint: 'Každý disk se rodí zde, ve výchozím formátu úložiště',
      fromDescriptionMetadataStorage: 'Úložiště metadat',
      fromDescriptionSameAsStorage: 'Stejné jako disky',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Bez bridge ani sítě se VM rodí bez karet',
      fromDescriptionNetwork: 'Logická síť (fabric/síť)',
      fromDescriptionSubmit: 'Vytvořit',
      fromDescriptionError: 'VM se nepodařilo vytvořit',
      fromDescriptionDone: 'VM vytvořeno: {name}',
      fromDescriptionOpen: 'Otevřít VM',
      fromDescriptionDenied: 'Chybí vám vm.create',
      fromDescriptionStillRunning: 'Vytváření stále běží: čeká se dál'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Zálohy dat virtuálních strojů',
      titleOnVm: 'Zálohy dat',
      empty: 'Žádná záloha. Záloha přenese disky, varstore UEFI a stav vTPM na cíl a přežije virtuální stroj.',
      colVm: 'VM',
      colCreated: 'Pořízena',
      colPhase: 'Výsledek',
      colDestination: 'Cíl',
      colContains: 'Obsah',
      colSize: 'Velikost',
      colOrigin: 'Původ',
      colMode: 'Typ',
      retentionChip: 'Retence',
      retentionHint:
        'Retence cíle může tuto zálohu smazat, aniž by se zeptala: zrodila se z plánu. Ruční zálohy se nikdy nezametají.',
      policyRemoved: 'Policy odstraněna: {name}',
      policyRemovedHint:
        'Policy, která tento backup naplánovala, už neexistuje: žádná retence ho neřídí (nikdy se neprořezává automaticky) — smažte ho ručně, až ho nebude třeba.',
      phase: {
        running: 'Probíhá',
        complete: 'Dokončena',
        error: 'Selhala'
      },
      origin: {
        manual: 'Ruční',
        schedule: 'Plánovaná'
      },
      mode: {
        full: 'Plná',
        incremental: 'Přírůstková'
      },
      contains: {
        disks: 'Disky',
        varstore: 'Varstore UEFI',
        vtpm: 'Stav vTPM',
        snapshots: 'Snímky'
      },
      vmState: {
        stopped: 'VM vypnutá',
        running: 'Běžící VM (za běhu)'
      },
      artifactClass: { metadata: 'Metadata', data: 'Data', secret: 'Tajemství' },
      detail: {
        tabOverview: 'Přehled',
        tabArtefact: 'Artefakt',
        id: 'Identifikátor',
        scope: 'Rozsah',
        vmState: 'Stav VM při kopírování',
        pointInTime: 'Okamžik dat',
        completedAt: 'Ukončena',
        node: 'Uzel, který kopíroval',
        error: 'Chyba',
        path: 'Adresář na úložišti',
        checksum: 'sha256 manifestu',
        secretsExposed: 'Citlivý materiál v otevřené podobě',
        secretsExposedYes: 'Ano — cíl nešifruje',
        secretsExposedNo: 'Ne',
        baseBackup: 'Základní záloha',
        tabManifest: 'Manifest',
        manifestHint:
          'Otevřený index artefaktu: jeden soubor na řádek se svým sha256. Adresář lze ověřit i bez TVirt — stačí qemu-img, tar a jq.',
        manifestEmpty: 'Manifest neuvádí žádné soubory.',
        manifestError: 'Manifest nelze přečíst',
        colEntry: 'Soubor',
        colClass: 'Třída',
        colSha: 'sha256'
      },
      create: {
        action: 'Zálohovat nyní',
        title: 'Zálohovat nyní',
        submit: 'Spustit zálohu',
        destination: 'Cíl',
        destinationHint: 'Jen cíle, které přijímají zálohy.',
        noDestinations: 'Žádný cíl nepřijímá zálohy: vytvořte jej v Systém → Checkpointy.',
        contentsHint:
          'Cestují všechny disky, varstore UEFI a stav vTPM. Ty poslední dva jsou to podstatné: zapečetěný host musí znovu nastartovat.',
        error: 'Záloha se nerozběhla',
        stillRunning: 'Záloha stále běží — kopírování pokračuje, i když zavřete.',
        vmRunning:
          'Virtuální stroj je {phase}: záloha potřebuje ustálený VM — vypnutý pro studenou kopii, běžící pro kopii za běhu.'
      },
      restore: {
        action: 'Obnovit',
        title: 'Obnovit',
        intro: 'Obnova je nevratná. Zvolte, kam se data vrátí: do nového stroje, nebo přes ten původní.',
        modeNewVm: 'Obnovit do NOVÉHO virtuálního stroje',
        modeNewVmHint:
          'Nesahá na nic, co existuje — touto volbou se záloha ověřuje. Nový identifikátor a čerstvě ražené adresy MAC.',
        modeOver: 'Přepsat původní virtuální stroj',
        modeOverHint: 'Zničí současná data cílového stroje, bez cesty zpět. Virtuální stroj musí být vypnutý.',
        newName: 'Název nového stroje',
        newNameHint: 'Musí být volný v cílovém rozsahu.',
        storage: 'Úložiště pro disky',
        storageHint: 'Povinné: manifest zaznamenává velikost a formát disku, nikdy úložiště, na kterém ležel.',
        metadataStorage: 'Úložiště pro varstore a vTPM',
        metadataStorageHint: 'Kam dopadnou identita UEFI a stav vTPM.',
        sameAsStorage: 'Stejné jako disky',
        bridge: 'Bridge hostitele',
        bridgeHint:
          'Každá zaznamenaná síťová karta se vrátí na tomto bridge s novou MAC. Ponecháno prázdné, stroj se narodí bez karet — bezpečnější výchozí volba.',
        overwriteTitle: 'Chystáte se přepsat tento virtuální stroj',
        overwriteName: 'Název',
        overwriteId: 'Identifikátor',
        overwriteDisks: 'Disky, které budou přepsány',
        overwriteNoDisks: 'Žádné disky.',
        overwriteKeeps:
          'Nedotčeny zůstávají identifikátor, název, rozsah, síťové karty a adresy MAC: záloha jsou DATA, konfigurace je checkpoint.',
        confirmField: 'Název stroje',
        confirmHint: 'Napište {name} pro potvrzení.',
        targetLoading: 'Načítání cílového stroje…',
        targetRunning: 'Cílový stroj je {phase}: obnova přepisuje bajty pod hostem, proto ho chce vypnutý.',
        targetGone: 'Původní stroj již nelze přečíst: zbývá obnova do nového stroje.',
        onlyComplete: 'Záloha je {phase}: obnovit může jen dokončená záloha.',
        submitNewVm: 'Obnovit do nového stroje',
        submitOver: 'Přepsat',
        error: 'Obnova se nerozběhla',
        stillRunning: 'Obnova stále běží — kopírování celých disků zabere čas.'
      }
    },
    guest: {
      title: {
        ct: 'Zálohy dat kontejnerů',
        app: 'Zálohy dat App'
      },
      tabTitle: 'Zálohy',
      empty: 'Žádné zálohy. Záloha kopíruje perzistentní data na cíl a přežije svůj objekt.',
      colSubject: {
        ct: 'Kontejner',
        app: 'App'
      },
      colCreated: 'Pořízena',
      colPhase: 'Výsledek',
      colDestination: 'Cíl',
      colContains: 'Obsah',
      colSize: 'Velikost',
      colOrigin: 'Původ',
      policyRemoved: 'Policy odstraněna: {name}',
      policyRemovedHint:
        'Policy, která tento backup naplánovala, už neexistuje: žádná retence ho neřídí (nikdy se neprořezává automaticky) — smažte ho ručně, až ho nebude třeba.',
      phase: {
        running: 'Probíhá',
        complete: 'Dokončena',
        error: 'Selhala'
      },
      origin: {
        manual: 'Ruční',
        schedule: 'Plánovaná'
      },
      state: {
        stopped: 'Objekt zastaven',
        running: 'Objekt běží (zmrazen)'
      },
      contains: {
        rootfs: 'Strom rootfs',
        config: 'Konfigurace',
        volumes: 'Perzistentní svazky',
        root: 'Perzistentní root'
      },
      artifactClass: {
        metadata: 'Metadata',
        data: 'Data',
        secret: 'Tajné'
      },
      create: {
        action: 'Zálohovat nyní',
        title: 'Nová záloha',
        submit: 'Spustit zálohu',
        error: 'Záloha se nespustila',
        destination: 'Cíl',
        destinationHint: 'Jen cíle, které přijímají zálohy dat.',
        noDestinations: 'Žádný cíl nepřijímá zálohy dat: přidejte cíli „Zálohy dat“.',
        hint: {
          ct: 'Cestuje celý strom rootfs, věrně (číselní vlastníci, xattrs, ACL), plus deklarovaná konfigurace v manifestu. Běžící kontejner je po dobu balení ZMRAZEN: crash-consistent kopie, deklarovaná.',
          app: 'Cestují JEN perzistentní svazky (a perzistentní root), plus konfigurace v manifestu. Efemérní části jsou ratifikací vyloučeny a manifest je jmenuje; env hodnoty deklarované jako tajné necestují.'
        },
        stillRunning: 'Záloha stále běží — balení celých stromů chvíli trvá.'
      },
      detail: {
        tabOverview: 'Přehled',
        tabManifest: 'Manifest',
        id: 'Identifikátor',
        scope: 'Rozsah',
        state: 'Stav při kopii',
        pointInTime: 'Data k okamžiku',
        completedAt: 'Dokončeno',
        node: 'Uzel, který kopíroval',
        error: 'Chyba',
        path: 'Adresář na úložišti',
        checksum: 'sha256 manifestu',
        manifestHint:
          'Index artefaktu: jeden záznam na soubor s jeho sha256 — bez hashů je „záloha tam je“ aktem víry.',
        manifestError: 'Manifest nelze přečíst',
        manifestEmpty: 'Žádné artefakty v manifestu.',
        colEntry: 'Soubor',
        colClass: 'Třída',
        colSha: 'sha256',
        excluded: 'Vyloučeno ratifikací (necestuje)',
        secretKeys: 'Vynechané tajné env klíče (#307) — po obnově je zadejte znovu'
      },
      restore: {
        action: 'Obnovit',
        title: 'Obnova',
        submit: 'Obnovit',
        error: 'Obnova se nespustila',
        stillRunning: 'Obnova stále běží — rozbalování celých stromů chvíli trvá.',
        onlyComplete: 'Záloha je {phase}: obnovit může jen dokončená záloha.',
        asNew: {
          ct: 'Do NOVÉHO kontejneru — nic neničí: gesto, kterým se záloha ověřuje',
          app: 'Do NOVÉ App — nic neničí: gesto, kterým se záloha ověřuje'
        },
        over: {
          ct: 'PŘES zdrojový kontejner — celý strom rootfs se nahradí',
          app: 'PŘES zdrojovou App — obsah každého perzistentního svazku se nahradí'
        },
        name: 'Název nového objektu',
        storage: 'Úložiště',
        storageHint: 'Kam obnovená data přistanou — manifest nikdy nezaznamenává ztracený pool.',
        storageDeclared: 'Úložiště deklarovaná v manifestu',
        bridge: 'Bridge hostitele',
        bridgeHint:
          'Každá zaznamenaná karta se vrátí na tento bridge s čerstvou MAC. Prázdné = rodí se nepřipojen, nejbezpečnější výchozí.',
        node: 'Uzel',
        nodeHint: 'Člen, na kterém se App znovu zrodí: uzel je identita clusteru a nikdy nepochází z manifestu.',
        secretKeysWarning:
          'Env hodnoty deklarované jako tajné v záloze necestují: znovuzrozená kopie je chce zadat znovu (log úlohy jmenuje klíče).',
        overInventory: 'Chystáte se přepsat tento objekt',
        confirmType: 'Napište {name} pro potvrzení',
        targetGone: 'Zdrojový objekt už nelze přečíst: obnova jako nový zůstává k dispozici.',
        targetLoading: 'Čtení cílového objektu…',
        targetRunning: 'Cílový objekt běží: obnova nahrazuje bajty pod hostem, chce ho tedy zastavený.'
      }
    }
  }
}
